import { DxpStorageService } from './storage.service';
import { Injectable } from '@angular/core';
import {
  LuigiAuthEventsCallbacksService,
  LuigiCoreService,
} from '@openmfp/portal-ui-lib';

@Injectable({ providedIn: 'root' })
export class DxpLuigiAuthEventsCallbacksService
  implements LuigiAuthEventsCallbacksService
{
  constructor(
    private storageService: DxpStorageService,
    private luigiCoreService: LuigiCoreService,
  ) {}

  onAuthSuccessful() {
    return undefined;
  }
  onAuthError() {
    return undefined;
  }
  onAuthConfigError() {
    return undefined;
  }

  onLogout() {
    this.storageService.clearLocalStorage();
    return true;
  }

  onAuthExpireSoon() {
    this.luigiCoreService.showAlert({
      text: 'Login session expires soon',
      type: 'warning',
    });
  }

  onAuthExpired() {
    this.storageService.clearLocalStorage();
  }
}
